<template>

<router-link :to="route" class="user" :class="{'is-offline':item.status === $constants.userStatus.disabled}" v-tooltip="'Click to edit'" v-on:click="$emit('click')">

    <div class="user-info">
    
        <div class="user-info-name">{{ item.name }}</div>
        <div class="user-info-email">{{ item.email }}</div>

    </div>

    <div class="user-date">

        {{ item.loggedin | localDate('DD/MM/YYYY') }}

    </div>

    <div class="user-icon">

        <i class="fa-solid fa-chevron-right" />

    </div>

</router-link>

</template>

<script>

export default {

    props: ['item'],

    computed: {
    
        route: function() {
        
            return {
                name: this.$route.meta.editName,
                params: {
                    id: this.item.id
                }
            }
        
        }
    
    }

}

</script>

<style scoped>

.user {
    padding: 10px;
    margin-bottom: 10px;
    border: 1px solid #eee;
    border-radius: 4px;
    display: grid;
    background-color: #fff;
    grid-template-columns: 1fr 120px 20px;
    grid-gap: 20px;
    align-items: center;
    border-left: 5px solid #43ac43;
    z-index: 20;
    cursor: pointer;
}

.user.is-offline {
    border-left: 5px solid #aa3737;
}

.user:hover {
    background-color: #f7f7f7;
}

.user-info-name {
    font-size: 16px;
    color: #343434;
}

.user-info-email {
    font-size: 12px;
    font-family: courier new;
    color: #999;
    margin-top: 4px;
}

.user-icon {
    font-size: 16px;
    text-align: right;
    color: #666;
}

</style>
